import React from 'react';
import { Users, CreditCard, PoundSterling, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const StatCard = ({ title, value, subtext, subtextColor, icon: Icon, bgColor, iconColor }) => (
  <Card>
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-600">{title}</p>
          <p className="text-3xl font-bold text-gray-900">{value}</p>
        </div>
        <div className={`w-12 h-12 ${bgColor} rounded-full flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
      </div>
      <p className={`text-sm ${subtextColor} mt-2`}>{subtext}</p>
    </CardContent>
  </Card>
);

export const DashboardStats = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatCard
        title="Total Bookings"
        value={stats.total_bookings || 0}
        subtext={`${stats.new_bookings || 0} new`}
        subtextColor="text-blue-600"
        icon={Users}
        bgColor="bg-blue-100"
        iconColor="text-blue-600"
      />
      <StatCard
        title="Total Payments"
        value={stats.total_payments || 0}
        subtext={`${stats.paid_payments || 0} completed`}
        subtextColor="text-green-600"
        icon={CreditCard}
        bgColor="bg-purple-100"
        iconColor="text-purple-600"
      />
      <StatCard
        title="Total Revenue"
        value={`£${stats.total_revenue?.toFixed(2) || '0.00'}`}
        subtext="From paid orders"
        subtextColor="text-gray-500"
        icon={PoundSterling}
        bgColor="bg-green-100"
        iconColor="text-green-600"
      />
      <StatCard
        title="Pending Actions"
        value={stats.new_bookings || 0}
        subtext="Need attention"
        subtextColor="text-yellow-600"
        icon={Clock}
        bgColor="bg-yellow-100"
        iconColor="text-yellow-600"
      />
    </div>
  );
};
